import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import packagesReducer from './slices/packagesSlice';
import userReducer from './slices/userSlice';
import brokerReducer from './slices/brokerSlice';
import uiReducer from './slices/uiSlice';
import chartReducer from './slices/chartSlice';
import marketReducer from './slices/marketSlice';

const store = configureStore({
    reducer: {
        auth: authReducer,
        packages: packagesReducer,
        user: userReducer,
        broker: brokerReducer,
        ui: uiReducer,
        chart: chartReducer,
        market: marketReducer,
    },
    devTools: import.meta.env.DEV,
});

export default store;